// Action Types
export const FETCH_GLOBAL_ACCOUNTS_REQUEST = "FETCH_GLOBAL_ACCOUNTS_REQUEST";
export const FETCH_GLOBAL_ACCOUNTS_SUCCESS = "FETCH_GLOBAL_ACCOUNTS_SUCCESS";
export const FETCH_GLOBAL_ACCOUNTS_FAILURE = "FETCH_GLOBAL_ACCOUNTS_FAILURE";

// Action Creators
export const FetchGlobalAccountsRequest = ({ start="100",rows="100",q="*:*",fq,type,userId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_GLOBAL_ACCOUNTS_REQUEST,
      payload: {start,rows,q,fq,type, userId },
    });
  };
};
export const FetchGlobalAccountsSuccess = (data) => ({
  type: FETCH_GLOBAL_ACCOUNTS_SUCCESS,
  payload: data,
});
export const FetchGlobalAccountsFailure = (error) => ({
  type: FETCH_GLOBAL_ACCOUNTS_FAILURE,
  payload: error,
});
